export const PUBLIC_WEB_VITAL_TARGETS = Object.freeze({
  LCP: 2500,
  INP: 200,
  CLS: 0.1,
});

export const getMetricTargetStatus = ({ name, value } = {}) => {
  const target = PUBLIC_WEB_VITAL_TARGETS[name];
  if (typeof target !== "number" || !Number.isFinite(value)) return null;
  return {
    target,
    meetsTarget: value <= target,
  };
};

const sendMetric = (metric) => {
  if (typeof window === "undefined") return;

  const targetStatus = getMetricTargetStatus(metric);
  const payload = {
    name: metric.name,
    value: metric.value,
    id: metric.id,
    rating: metric.rating,
    delta: metric.delta,
    navigationType: metric.navigationType,
    pathname: window.location.pathname,
    timestamp: Date.now(),
    ...targetStatus,
  };

  window.__TRACKME_WEB_VITALS__ = [
    ...(Array.isArray(window.__TRACKME_WEB_VITALS__) ? window.__TRACKME_WEB_VITALS__ : []),
    payload,
  ].slice(-50);
  window.dispatchEvent(new CustomEvent("trackme:web-vital", { detail: payload }));

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: "web_vital", ...payload });
  }

  const endpoint = String(process.env.REACT_APP_WEB_VITALS_ENDPOINT || "").trim();
  if (endpoint && typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
    navigator.sendBeacon(endpoint, JSON.stringify(payload));
  }

  if (process.env.NODE_ENV === "development") {
    console.debug("[web-vitals]", payload);
  }
};

const reportWebVitals = (onPerfEntry = sendMetric) => {
  if (typeof onPerfEntry !== "function") return;

  import("web-vitals").then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
    onCLS(onPerfEntry);
    onFCP(onPerfEntry);
    onINP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  });
};

export default reportWebVitals;
